import { useContext, useState } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track } from 'modules/core/lib/Tracking'

import { UninstallModal } from 'modules/marketplace/components/Item/UninstallModal'
import { useGetMarketplaceFormQuestions } from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceFormQuestions'

import { CompanyInstallation as CompanyInstallationButton } from './CompanyInstallation'

interface InternalIntegrationInstallationButtonInterface {
  integration: ItemIntegrationFragment
}

export const InternalIntegrationInstallationButton = ({
  integration,
}: InternalIntegrationInstallationButtonInterface) => {
  const [questionPropertiesPresent, setQuestionPropertiesPresent] = useState(false)
  const [uninstallModalVisible, setUninstallModalVisible] = useState(false)
  const [handleUninstall, setHandleUninstall] = useState(false)
  const { component, installable, id, name } = integration
  const environment = useContext(EnvironmentContext)
  const oauth_redirect = `${environment.apiEndpoint}/integrations/${integration.datoId}/authorize`
  const skipFormQuestionsQuery = !component || !id ? true : !installable

  const {
    access: { id: accessId },
    company: { id: companyId },
  } = useCurrentSession()

  const { data: formQuestionsData, loading } = useGetMarketplaceFormQuestions(
    {
      integrationId: id || -1,
      companyId: companyId,
      accessId: accessId,
    },
    skipFormQuestionsQuery
  )

  useEffect(() => {
    if (formQuestionsData.at(0)) {
      const parsedFormQuestions = JSON.parse(formQuestionsData.at(0)?.formQuestions || '{}')
      setQuestionPropertiesPresent(Object.keys(parsedFormQuestions).length > 0)
    }
  }, [formQuestionsData.at(0)?.formQuestions])

  const trackEvent = (event: string) => {
    track(event, {
      integrationDatoId: integration.datoId,
      integrationName: integration.name,
    })
  }

  if (loading) return <Spinner />
  return (
    <Box paddingTop="s12">
      <CompanyInstallationButton
        integration={integration}
        questionPropertiesPresent={questionPropertiesPresent}
        oauth_redirect={oauth_redirect}
        setUninstallModalVisible={setUninstallModalVisible}
        handleUninstall={handleUninstall}
        trackEvent={trackEvent}
      />
      {uninstallModalVisible && (
        <UninstallModal
          onClose={() => setUninstallModalVisible(false)}
          onClickUninstall={() => {
            setHandleUninstall(true)
            localStorage.removeItem('datev_lauds_form_data')
          }}
          integrationName={name}
        />
      )}
    </Box>
  )
}
